import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {DocumentoPac} from "../model/DocumentoPac";

@Injectable({
  providedIn: 'root'
})
export class PesquisaPacStateService {

  initialState: PesquisaPacState = {
    exibePesquisaAvancada: false,
    criterio: "",
    pacs: [],
  }

  state: Subject<PesquisaPacState> = new BehaviorSubject<PesquisaPacState>(this.initialState);

  state$ = this.state.asObservable();

  update(newState: PesquisaPacState) {
    this.state.next(newState);
  }
}

export interface PesquisaPacState {

  exibePesquisaAvancada: boolean;
  pacs: DocumentoPac[];

  // Critério básico
  criterio?: string;
  // Critérios Avançados
  criterioProposta?: string;
  criterioAno?: number;
  criterioPac?: string;
  criterioComprador?: string;

}
